
import { ClipboardList } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export const EmptyState = () => {
  const navigate = useNavigate();
  
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4">
      <ClipboardList className="h-16 w-16 text-gray-400 mb-4" />
      <h2 className="text-xl font-semibold text-gray-700 mb-2">No Assessments Found</h2>
      <p className="text-gray-500 text-center mb-6">
        You haven't completed any assessments yet. Start your first assessment to see your results here.
      </p>
      <Button onClick={() => navigate("/assessment")} className="mt-2">
        Start Your First Assessment
      </Button>
    </div>
  );
};
